// src/api/adminFunnelCampaigns.ts
import { V1, authFetch } from "api/client";

/**
 * One campaign name the app funnel may send to Plausible. `admin` names were added on
 * the admin page and can be removed there. `config` names come from the deploy-time
 * list, are still sent until that list is retired, and cannot be removed here.
 */
export interface FunnelCampaign {
  name: string;
  source: "admin" | "config";
  added_by: string | null;
  added_at: string | null; // ISO
  removed_by: string | null;
  removed_at: string | null; // ISO
}

export interface FunnelCampaignsOut {
  /** The server's name rule, in words. The server is the check; the page only shows it. */
  rule: string;
  items: FunnelCampaign[];
}

const BASE = `${V1}/admin/funnel-campaigns`;

export async function adminListFunnelCampaigns(
  opts: { includeRemoved?: boolean } = {}
): Promise<FunnelCampaignsOut> {
  const params = new URLSearchParams({ include_removed: String(opts.includeRemoved ?? false) });
  return authFetch<FunnelCampaignsOut>(`${BASE}?${params.toString()}`, { method: "GET" });
}

/** 201 with the stored name; 409 if it is already live; 422 with a message per field. */
export async function adminAddFunnelCampaign(name: string): Promise<FunnelCampaign> {
  return authFetch<FunnelCampaign>(BASE, { method: "POST", body: JSON.stringify({ name }) });
}

/** 204; 404 if the name is not on the stored list. */
export async function adminRemoveFunnelCampaign(name: string): Promise<void> {
  await authFetch<void>(`${BASE}/${encodeURIComponent(name)}`, { method: "DELETE" });
}
